import { CuratedDealFeesDetailsSection } from '../../../DealDetails/sections/CuratedDealFeesSection/CuratedDealFeesDetailsSection';
import { useDealContext } from '../../../utils/context/DealContext';

export const CuratedDealFeesFormSectionReadOnly = () => {
  const { useDealFormSelector } = useDealContext();
  const {
    dealForm: { currentDeal },
  } = useDealFormSelector();

  return currentDeal && <CuratedDealFeesDetailsSection deal={currentDeal} />;
};
